import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './Header.css';
import Left from './components/Left';
import { useExternalMedia } from "../../../../hooks/useExternalMedia";








export default function Header() {

  const { joyfulCareWaves } = useExternalMedia()


  const backgroundStyle = {
    backgroundImage: `url(${joyfulCareWaves})`,
    backgroundSize: "cover",
    backgroundPosition: "left",
    backgroundRepeat: "no-repeat",
    minHeight: "300px",
    minWidth: "300px",
  }
  return (

    <>
      <section>
        <Container>
          <Row>
            <Col
              xs={{ span: 12, order: 2 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 5, order: 1 }}
            >
              <Left />
            </Col>
            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 7, order: 2 }}
              style={{
                ...backgroundStyle,
              }}
            >
            </Col>
          </Row>

        </Container>
      </section>
    </>
  )
}
